import CustomIdChange from "./custom-id-change"
import BulkUpload from "./bulk-upload"
import GuideToPresentation from "./guide-to-presentation"
import LearningObjectiveToObjective from "./learning-objective-to-objective"

const tools = [CustomIdChange, BulkUpload, GuideToPresentation, LearningObjectiveToObjective]

export default tools.filter(tool => tool.available)
